<button
  type="button"
  mat-icon-button
  [attr.aria-label]="'partners.users.actions.more' | translate"
  [disabled]="loading"
  [matMenuTriggerFor]="menu"
  (click)="$event.stopPropagation()">
  @if (loading) {
    <mat-progress-spinner
      class="block"
      mode="indeterminate"
      [diameter]="24" />
  } @else {
    <mat-icon svgIcon="remix:System/more-2-line" />
  }
</button>
<mat-menu #menu="matMenu">
  @for (item of actions; track item.action) {
    <button
      type="button"
      mat-menu-item
      (click)="selected.emit(item.action)">
      <mat-icon [svgIcon]="item.icon" />
      <span>{{ item.text | translate }}</span>
    </button>
  }
</mat-menu>
